
















import { toCzj } from '@/app/core/utils'
import { Component, Mixins } from 'vue-property-decorator'
import RecommendItem from './mixins/RecommendItem'

@Component
export default class TeacherItem extends Mixins(RecommendItem) {
  get teacherWork() {
    if (this.value.urls) {
      try {
        const s = JSON.parse(this.value.urls)
        return s[0] || {}
      } catch (e) {
        return (this.value.urlList && this.value.urlList[0] && this.value.urlList[0]) || {}
      }
    }
    return {}
  }
  get teacherWorkUrl() {
    return this.teacherWork.url || ''
  }

  get imgHRate() {
    const { coverWidth, coverHeight } = this.teacherWork
    let rate = 1
    if (coverWidth && coverHeight) {
      rate = coverWidth / coverHeight
      rate = rate < 3 / 4 ? 3 / 4 : rate > 4 / 3 ? 4 / 3 : rate
    }
    return rate
  }

  get goDetailExposure() {
    const { id, uid } = this.value
    return `200022||${JSON.stringify({ knowledge: id, fuid: uid, tabname: this.tab.tabName })}`
  }
  goDetail() {
    const { id, uid } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200022', positionParam: { knowledge: id, fuid: uid, tabname: this.tab.tabName } })
  }

  get linkUrl() {
    return this.kwtarget(toCzj(`https://m.czj100.com/details/works/${this.value.id}`, false))
  }
}
